{{#each forwardTypedefs tn=true}}
typedef class {{ type }};
{{/each}}
